import PropTypes from 'prop-types'
import styles from './GenericModal.module.css'

export const GenericItems = ({ items, body, onSelect, onClose }) => {
  return (
    <>
      {items.length > 0 ? (
        <div className={styles.lista}>
          {items.map((item) => (
            <div
              key={item.value}
              className={styles.item}
              onClick={() => {
                if (onSelect) {
                  onSelect(item)
                }

                onClose()
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      ) : (
        <p>{body}</p>
      )}
    </>
  )
}

GenericItems.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired
    })
  ),
  body: PropTypes.string,
  onSelect: PropTypes.func,
  onClose: PropTypes.func
}
